<script>
    import {onDestroy} from 'svelte';
    import R, {LOADER} from "../lib/requests";
    import {OBJECTS} from "../lib/constants";
    import clocking from "../stores/clocking";
    import charges from "../stores/charges";
    import {formatDate, humanDate, millisecondsToHours} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import ClockingTask from "./ClockingTask.svelte";
    import TaskItem from "./TaskItem.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TasksSearch from "./TasksSearch.svelte";
    import TaskEditModal from "./TaskEditModal.svelte";
    import MergeTasksModal from "./MergeTasksModal.svelte";
    import Notifier from "../stores/notifier";


    let tasks = null;
    let dateGroups = [];
    let editId = null;

    let selectGroupId = null;
    let selectGroupDate = null;
    let selectedTasks = [];
    let mergeTasks = false;

    let search = {
        name: '',
        project_id: null,
        sort_field: 'start_at',
        sort_way: 'DESC',
    }
    let clockingTask;


    let pageHeaderControls = [
        {key: 'create', name: 'ΝΕΑ ΕΡΓΑΣΙΑ'},
        {key: 'select', name: '', icon: 'plus-square', tip: 'επιλογή εργασιών για χρέωση'},
        {key: 'charge', name: '', icon: 'bolt', tip: 'δημιουργία χρέωσης', hidden: true},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            if (selectGroupId != null) {
                event.preventDefault();
                event.stopPropagation();
                cancelSelection();
                setPageHeaderControls();
            }
        }
    }

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            tasks = new Map();
            result.map(task => {
                task.date = formatDate(task.start_at, 'y-m-d');
                task.startTime = formatDate(task.start_at, 'H:i');
                task.endTime = formatDate(task.end_at, 'H:i');
                task.durationTime = millisecondsToHours(task.duration);
                tasks.set(~~task.id, task);
            });
            // console.log("TASKS", tasks.get(62));
            setDateGroups();
        }

        const onFailure = err => {
        };


        R.handle(R.task.index, search, onSuccess, onFailure, loader);
    }


    const onSearch = (data) => {
        search = data;
        load();
    }

    const setDateGroups = () => {
        dateGroups = [];

        tasks.forEach(task => {
            let group = dateGroups.find(x => x.date === task.date);
            if (!group) {
                group = {
                    date: task.date,
                    name: humanDate(task.start_at),
                    total_duration: ~~task.duration,
                    tasks: [~~task.id],
                }
                dateGroups = [...dateGroups, group];
            } else {
                group.total_duration += ~~task.duration;
                group.tasks = [...group.tasks, ~~task.id];
            }
        });
    }

    const completeEdit = param => {
        editId = null;
        if (param) {
            load();
        }
    }

    const onDelete = ({detail: id}) => {
        tasks.delete(~~id);
        setDateGroups();
    }

    const onArchive = ({detail: id}) => {
        tasks.delete(~~id);
        setDateGroups();
    }

    const onRestart = ({detail}) => {
        clocking.start({
            name: detail.name,
            project_id: detail.project_id,
            project: detail.project,
            tags: detail.tags
        });
    }

    const setPageHeaderControls = () => {
        let selectControl = pageHeaderControls.find(x => x.key === 'select');
        let chargeControl = pageHeaderControls.find(x => x.key === 'charge');

        if (selectGroupId == null) {
            selectControl.icon = 'plus-square';
            selectControl.tip = 'επιλογή εργασιών για χρέωση';
            chargeControl.hidden = true;
        } else {
            if (!selectGroupDate) {
                chargeControl.hidden = !selectedTasks.length;
            }
            selectControl.icon = 'minus-square';
            selectControl.tip = 'ακύρωση επιλογής εργασιών';
        }

        pageHeaderControls = pageHeaderControls;
    }

    const clearSelected = () => {
        tasks.forEach(task => {
            delete (task.is_selected);
        });
    }

    const cancelSelection = () => {
        selectGroupDate = null;
        selectGroupId = null;
        selectedTasks = [];
        clearSelected();
    }

    const onToggle = ({detail}) => {
        selectedTasks = Array.from(tasks.values()).filter(x => x.is_selected).map(item => item.id);
        if (!selectedTasks.length) {
            selectGroupId = 0;
        } else {
            selectGroupId = detail.group_id;
        }
        console.log("onToggle", selectedTasks);

        setPageHeaderControls();
    }


    /* Tasks charge handlers */

    const onToggleCharge = () => {
        if (selectGroupId == null) {
            selectGroupId = 0;
        } else {
            cancelSelection();
        }

        setPageHeaderControls();
    }


    const onGroupCharge = () => {
        if (!selectedTasks.length) {
            Notifier.showError("Δεν έχετε επιλέξει εργασίες για χρέωση!");
            return;
        }

        let objects = [];
        selectedTasks.map(id => {
            objects.push({object_type: OBJECTS.TASK, object_id: id});
        });

        charges.create(objects, null, (param) => {
            if (param) {
                param.objects.map(item => {
                    if (item.object_type == OBJECTS.TASK) {
                        let task = tasks.get(~~item.object_id);
                        task.charge_id = param.id;
                    }
                });
                dateGroups = dateGroups;
                cancelSelection();
                setPageHeaderControls();
            }
        });
    }


    /* Tasks merge handlers */

    const onToggleMerge = (dateItem) => {
        if (selectGroupDate === dateItem.date) {
            cancelSelection();
        } else {
            selectGroupDate = dateItem.date;
            selectGroupId = 0;
            clearSelected();
        }
    }

    const onMerge = () => {
        if (selectedTasks.length < 2) {
            // cannot group only one task
            Notifier.showError("Επιλέξτε 2 ή περισσότερες εργασίες για συγχώνευση");
            return;
        }

        mergeTasks = true;
    }

    const completeMerge = (params) => {
        mergeTasks = false;
        if (params) {
            load();
        }
    }

    onDestroy(() => {
        document.removeEventListener('keydown', handleEscapeKey);
    });

    document.addEventListener('keydown', handleEscapeKey);
    load(LOADER.PAGE);
</script>

<PageHeader title="Εργασίες" page="task" controls={ pageHeaderControls }
            on:create={ () => editId = 0 }
            on:select={ onToggleCharge }
            on:charge={ onGroupCharge }
            on:reload={ load }/>


<ClockingTask bind:this={ clockingTask } on:complete="{ load }"/>

<TasksSearch {search} searchCallBack="{ onSearch }"/>

{#if tasks}
    <div>
        {#each dateGroups as dateItem}
            <div class="panel panel-default box-border mb-6">
                <div class="panel-heading">
                    <div class="title-sm">{ dateItem.name }</div>
                    <div class="d-flex align-items-center">
                        { millisecondsToHours(dateItem.total_duration) }
                        {#if dateItem.tasks.length > 1}
                            {#if selectGroupDate === dateItem.date && selectedTasks.length > 1}
                                <button class="btn btn-default btn-sm ms-2" title="συγχώνευση εργασιών"
                                        on:click={ onMerge }>
                                    <AppIcon icon="check" size="14" strokeWidth="2"/>
                                </button>
                            {/if}
                            <button class="btn btn-sm ms-2" class:btn-default={ selectGroupDate !== dateItem.date }
                                    class:btn-primary={ selectGroupDate === dateItem.date }
                                    title="επιλογή εργασιών για συγχώνευση"
                                    on:click={ () => onToggleMerge(dateItem) }
                                    disabled="{ selectGroupId != null && selectGroupDate == null }">
                                <AppIcon icon="layers" size="14" strokeWidth="2"/>
                            </button>
                        {/if}
                    </div>
                </div>
                <div class="panel-body">
                    {#each dateItem.tasks as taskId}
                        <TaskItem task="{ tasks.get(taskId) }"
                                  groupId="{ selectGroupId }"
                                  groupDate="{ selectGroupDate }"
                                  on:edit="{ ({detail}) => editId = detail.id }"
                                  on:delete={ onDelete }
                                  on:archive={ onArchive }
                                  on:restart={ onRestart }
                                  on:toggle={ onToggle }
                        />
                    {/each}
                </div>
            </div>
        {/each}
    </div>
{/if}

{#if editId != null}
    <TaskEditModal taskId="{ editId }" closeCallback="{ completeEdit }"/>
{/if}
{#if mergeTasks}
    <MergeTasksModal tasks="{ selectedTasks }" closeCallback="{ completeMerge }"/>
{/if}
